import styled from 'styled-components';
import { Button } from 'antd';

export const CardContainer = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d1d5db;
  }
`;

export const MainContent = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr 250px;
  align-items: start;
`;

export const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 120px;
`;

export const ProductImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductName = styled.h3`
  font-size: 14px;
  font-weight: 400;
  color: #262626;
  margin: 0;
  line-height: 1.4;
  max-width: 200px;
`;

export const NotConfirmedLabel = styled.span`
  margin-left: auto;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 700;
  color: #f5222d;
  cursor: help;
`;

export const ConceptName = styled.p`
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #262626;
  margin: 0;
  line-height: 1.4;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Producer = styled.span`
  font-size: 14px;
  color: #8c8c8c;
  margin: 0;
`;

export const QualityWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  height: 100%;
`;

export const DetailsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-bottom: 1px solid #f0f0f0;
  padding: 8px;
  align-items: center;
`;

export const NameConceptGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const AttributesGrid = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 1px solid #f0f0f0;
  padding: 8px;
  flex-flow: wrap;

  .quality-container {
    margin-left: 22px;
  }

  .info-value {
    margin-left: 22px;
  }
`;

export const DeliveryInfo = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
  align-items: center;
`;

export const InfoGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px;
  height: 100%;
`;

export const PriceColumn = styled.div``;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
`;

export const TotalPriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const ActionsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const FreightInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff7e6;
  border-radius: 6px;
  padding: 2px;
`;

export const FreightPrice = styled.span`
  font-size: 10px;
  color: #f78e1e;
  font-weight: 700;
`;

export const Label = styled.span`
  font-size: 10px;
  color: #8c8c8c;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 6px;

  .anticon {
    font-size: 14px;
    color: #f88f1f;
  }
`;

export const Value = styled.span`
  font-size: 13px;
  color: #262626;
  font-weight: 500;
  padding-left: 22px;
`;

export const ProducerValue = styled.span`
  font-size: 10px;
  color: #f78e1e;
  font-weight: 700;
`;

export const SectionTitle = styled.h4`
  font-size: 10px;
  color: #f78e1e;
  font-weight: 400;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const Price = styled.span`
  font-size: 10px;
  color: #262626;
  font-weight: 400;
`;

export const TotalPrice = styled.span`
  font-size: 16px;
  color: #000;
  font-weight: 700;
`;

export const RemoveButton = styled(Button)`
  background: white;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
  font-size: 14px;
  height: 32px;
  padding: 8px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  font-weight: 500;

  &:hover {
    background: #fff1f0;
    border-color: #ff4d4f;
    color: #ff4d4f;
  }

  &:focus {
    background: white;
    border-color: #ff4d4f;
    color: #ff4d4f;
  }

  &:active {
    background: #fff1f0;
    border-color: #ff4d4f;
    color: #ff4d4f;
  }
`;
